import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu, X } from 'lucide-react'
import { cn } from '@/lib/utils'

type MobileMenuToggleProps = {
  onToggle: () => void
  isOpen: boolean
  className?: string
}

export const MobileMenuToggle = memo(function MobileMenuToggle({
  onToggle,
  isOpen,
  className,
}: MobileMenuToggleProps) {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'inline-flex h-11 w-11 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-secondary/50 hover:text-foreground',
        className,
      )}
      aria-label={isOpen ? t('common.collapse') : t('common.expand')}
    >
      {isOpen ? <X size={20} strokeWidth={2} /> : <Menu size={20} strokeWidth={2} />}
    </button>
  )
})
